package ir.yusefpasha.models

import ir.yusefpasha.util.Res

enum class Portfolio(
    val image: String,
    val title: String,
    val description: String,
    val link: String
) {
    One(
        image = Res.Image.PORTFOLIO_1,
        title = "Crypto App",
        description = "Coming soon... :)",
        link = Res.Links.GITHUB
    ),
    Two(
        image = Res.Image.PORTFOLIO_2,
        title = "LEGZO App",
        description = "Coming soon... :)",
        link = Res.Links.GITHUB
    ),
    Three(
        image = Res.Image.PORTFOLIO_3,
        title = "Daily-Check App",
        description = "Healthy App for Daily Check + Server",
        link = Res.Links.GITHUB
    ),
    Four(
        image = Res.Image.PORTFOLIO_4,
        title = "Musicx App",
        description = "Simple Music App for Listen to Music",
        link = Res.Links.GITHUB
    ),
    Five(
        image = Res.Image.PORTFOLIO_5,
        title = "KLA App",
        description = "Kharazmi-Institute Application For Teacher and Student",
        link = Res.Links.GITHUB
    ),
    Six(
        image = Res.Image.PORTFOLIO_6,
        title = "Weather App",
        description = "Simple Weather App for Check Weather",
        link = Res.Links.GITHUB
    ),
}